import AuditTrail from './AuditTrail';
import AuditTrailConnector from './AuditTrailConnector';

const ConnectedComponent = () => <AuditTrailConnector component={AuditTrail} />;

export default ConnectedComponent;
